module.exports = __webpack_public_path__ + "media/assets/images/post-bg/post-bg-5-5783a3b3b9ea617fbe5c60e576012b15.jpg";